import { NumberDisplayFormat } from '@teko/types/ecommerce';

export * from './buildpc';
export * from './categories';
export * from './file';
export * from './hamper';
export * from './local';
export * from './loyalty';
export * from './nav-items';
export * from './orders';
export * from './privacyPolicy';
export * from './profile';
export * from './regex';
export * from './search';
export * from './smartBanner';
export * from './terminal';
export * from './threeLevelLocation';
export const INTERNAL_REQUEST_TIMEOUT_MS = 2000;
// please do not export ibank from here
// it would affect server code
// export * from './ibank';

export const LOGIN_METHOD = {
  FACEBOOK: 'FACEBOOK',
  GOOGLE: 'GOOGLE',
  PHONE: 'PHONE',
};

export const DEFAULT_NUMBER_DISPLAY_FORMAT: NumberDisplayFormat = {
  thousandSeparator: '.',
  decimalSeparator: ',',
};
